export default __webpack_public_path__ + "static/media/woocommerce-light.42278612.svg";